// generated by genversion
export var version = '4.2.7';
//# sourceMappingURL=version.js.map